import { Banner, Button } from '@dev-spendesk/grapes';
import { useHistory } from 'react-router-dom';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';

type Props = {
  className?: string;
};

export const RulesSimplePromoBanner = ({ className }: Props) => {
  const history = useHistory();
  const companyId = useCompanyId();
  const { t } = useTranslation('global');

  return (
    <Banner
      className={className}
      variant="neutral"
      title={
        <span className="title-l">
          {t(
            'bookkeep.integrations.settings.payableRules.simplePromoBannerTitle',
          )}
        </span>
      }
      actions={
        <Button
          variant="secondaryNeutral"
          text={t(
            'bookkeep.integrations.settings.payableRules.simplePromoBannerCta',
          )}
          onClick={() => {
            history.push(
              routeFor(routes.COMPANY_ACCOUNTING_PAYABLE_RULES_SETUP.path, {
                company: companyId,
              }),
            );
          }}
        />
      }
    >
      {t(
        'bookkeep.integrations.settings.payableRules.simplePromoBannerContent',
      )}
    </Banner>
  );
};
